module.exports = __webpack_public_path__ + "static/media/icon-home.e49cb252.svg";